import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { failedResponse, getBackendUrl, loaded, loading, error, LoadStateInfo, notStarted } from "../common";
import { getToken } from "../../features/user/UserAvatar";
import { ObjectTarget } from "../../app/permissions";
import { ConversationInfo } from "./conversationSlice";
import { RootState } from "../../app/store";

export interface ConvPartRequest {
    objectTarget: ObjectTarget;
    targetId: string;
}

export interface ConversationCreateRequest {
    conversationType: number;
    parties: ConvPartRequest[];
}

export const performConversationCreate = createAsyncThunk(
    "performConversationCreate",
    async (param: ConversationCreateRequest, thunkAPI) => {
        console.debug("retrieve conversation list");

        const response = await fetch(`${getBackendUrl()}/api/conversation`, {
            method: "POST",
            signal: thunkAPI.signal,
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${getToken()}`,
            },
            body: JSON.stringify(param)
        });

        if (response.ok) {
            return await response.json();
        } else {
            return thunkAPI.rejectWithValue(failedResponse(response));
        }
    }
);

export interface ConversationCreateState {
    state: LoadStateInfo;
    request?: ConversationCreateRequest;
    response?: ConversationInfo;
}

const initialState: ConversationCreateState = {
    state: notStarted(),
};

export const conversationCreateSlice = createSlice({
    name: "conversationCreate",
    initialState,
    reducers: {
        clean: (state) => {
            state.state = notStarted();
            state.request = undefined;
            state.response = undefined;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(performConversationCreate.pending, (state, action) => {
                state.state = loading();
                state.request = action.meta.arg;
                state.response = undefined;
            })
            .addCase(performConversationCreate.fulfilled, (state, action) => {
                console.debug(`${action.type}`);
                state.state = loaded();
                state.response = action.payload;
            })
            .addCase(performConversationCreate.rejected, (state, action) => {
                state.state = error(action);
                state.response = undefined;
            });
    },
});

export const { } = conversationCreateSlice.actions;

export const selectConversationCreate = (state: RootState) => state.conversationCreate;

export default conversationCreateSlice.reducer;
